export const env = {
  apiUrl: process.env.REACT_APP_API_URL ?? '',
  siteName: process.env.REACT_APP_SITE_NAME ?? 'eOne Store',
  defaultLocale: process.env.REACT_APP_DEFAULT_LOCALE ?? 'es-AR',
  defaultCurrency: process.env.REACT_APP_DEFAULT_CURRENCY ?? 'ARS',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  isTest: process.env.NODE_ENV === 'test',
} as const;
